var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.load)?_c('div',{staticClass:"pay-loading"},[_c('div',{staticClass:"loading-content"},[_c('lottie',{staticStyle:{"width":"250px"},attrs:{"options":_vm.defaultOptions,"height":60}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }